import remote from './remote';

export function makeDeposit(data) {
  return remote.post('payments', data);
}

export function deletePaymentMethod(id) {
  return remote.delete(`payments/${id}`);
}

export function paypalCreate(data) {
  return remote.post('paypal-payment/create', data);
}

export function paypalDeposit(data) {
  return remote.post('paypal-payment/deposit', data);
}

export function razorpayCheckDepositLimit(query = {}) {
  return remote.get('razorpay/check_deposit_limit', query);
}

export function razorpayDeposit(data) {
  return remote.post('razorpay/deposit', data);
}

export function toggleCommunicationPreferences(data) {
  return remote.post('users/communication_preference', data);
}

export function getPromotionBonusAmount(query) {
  return remote.get('promotions/bonus_amount', query);
}

export function getTransactions(query = {}) {
  return remote.get('transactions', query);
}

export function getWithdrawalAccounts() {
  return remote.get('withdraws');
}

export function smsCodeLogin(data) {
  return remote.post('users/code', data);
}

export function verifySMSCode(data) {
  return remote.post('users/code/check', data);
}

export function withdrawWinnings(data) {
  return remote.post('withdraws', data);
}

export function uploadDocument(paymentId, data) {
  return remote.post(`withdraws/${paymentId}/documents`, data);
}

export function createLimits(data) {
  return remote.post('limits', data);
}

export function selfExclude() {
  return remote.post('users/self_exclude');
}

export function takeABreak(data) {
  return remote.post('users/break', data);
}
